import { render } from "./Focus.vue?vue&type=template&id=715fc222&scoped=true"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"

import "./Focus.vue?vue&type=style&index=0&id=715fc222&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715fc222"]])

export default __exports__